"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AGORA_ACTIVE_SPEAKER_INTENSITY_THRESHOLD = exports.ACTIVE_SPEAKER_INTENSITY_THRESHOLD = void 0;
// Score for Audio Intensity varies from 0 to 1 , we are setting value to be 0.1 which is threshold value found experimentally
var ACTIVE_SPEAKER_INTENSITY_THRESHOLD = exports.ACTIVE_SPEAKER_INTENSITY_THRESHOLD = 0.1;
// Agora Score for Audio Intensity varies from 0 to 1. Usually a user with volume above 0.5 is a speaking user.
var AGORA_ACTIVE_SPEAKER_INTENSITY_THRESHOLD = exports.AGORA_ACTIVE_SPEAKER_INTENSITY_THRESHOLD = 0.5;